import { Controller } from "@hotwired/stimulus"
import * as d3 from "d3"

// Connects to data-controller="keyword"
export default class extends Controller {
  connect() {
  }

  disconnect(){
  }
}
